module.exports = __webpack_public_path__ + "img/93.7.Chla.3222800c.png";